import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=85d1e85c&scoped=true"
import script from "./paginator.vue?vue&type=script&lang=js"
export * from "./paginator.vue?vue&type=script&lang=js"
import style0 from "./paginator.vue?vue&type=style&index=0&id=85d1e85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d1e85c",
  null
  
)

export default component.exports